import { render, staticRenderFns } from "./accessoryModal.vue?vue&type=template&id=4128ad81&"
import script from "./accessoryModal.vue?vue&type=script&lang=js&"
export * from "./accessoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports